<template>
    <main-toolbar>
        <div class="sales-select-box-wrapper">
            <div>
                <search-select-auto-complete
                    :items="options.rentalcompanyId"
                    :label="'업체' | translate"
                    class="sales-select-box-style mr-3"
                    v-model="innerSelectOptions.rentalcompanyId"
                    @input="innerSelectOptions.pageNumber = 1"
                    :error="!value.rentalcompanyId"
                />

                <div v-if="!value.rentalcompanyId" class="rental-error-message ml-2">
                    입대업체명을 선택해주세요!
                </div>
            </div>
            <select-box-multi-check
                :items="options.paymentStatusList"
                :label="'납부방법' | translate"
                class="sales-select-box-style pa-0 mr-3"
                v-model="innerSelectOptions.paymentStatusList"
                @input="innerSelectOptions.pageNumber = 1"
            />
            <select-box-single-check
                :items="options.baseSearchDateType"
                :label="'날짜 조회 기준' | translate"
                class="sales-select-box-style pa-0 mr-3"
                v-model="innerSelectOptions.baseSearchDateType"
                @input="innerSelectOptions.pageNumber = 1"
            />
            <search-date-range-picker
                :disable="datepickerDisable"
                @update:range="onSearchDateChanged"
                :label-for-end="'기간 종료일' | translate"
                :label-for-start="'기간 시작일' | translate"
                style="width: 320px;"
            />
        </div>
    </main-toolbar>
</template>

<script>
/**
 * 입출금 내역 페이지에서 나오는 셀렉트 버튼 입니다.
 */
import MainToolbar from "@/components/common/layout/MainToolbar";
import SearchSelectAutoComplete from "@/components/selectBox/SearchSelectAutoComplete";
import SelectBoxSingleCheck from "@/components/selectBox/SelectBoxSingleCheck";
import selectOptions from "@/components/selectBox/selectOptions";
import SelectBoxMultiCheck from "@/components/selectBox/SelectBoxMultiCheck";
import {PATH} from "@/constants";
import SearchDateRangePicker from "@/components/input/SearchDateRangePicker";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";

export default {
    name: "SelectBoxFilterGroup",
    mixins: [TotalCodeOptions],
    components: {
        SearchDateRangePicker,
        SearchSelectAutoComplete,
        SelectBoxSingleCheck,
        SelectBoxMultiCheck,
        MainToolbar

    },
    data() {
        return {
            options: {
                rentalcompanyId: [],
                baseSearchDateType: selectOptions.DEPOSIT_LIST.BASE_SEARCH_DATA_TYPE_OPTIONS,
                paymentStatusList: selectOptions.DEPOSIT_LIST.PAYMENT_STATUS_LIST_OPTIONS,
            },
            innerSelectOptions: undefined,
        }
    },
    computed: {
        datepickerDisable() {
            return !this.value.baseSearchDateType
        }
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
    },
    watch: {
        value: {
          immediate: true,
          deep: true,
          handler(newValue) {
              this.innerSelectOptions = newValue
          }
        },
        innerSelectOptions: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.$emit('input', newValue)
            }
        },
    },
    methods: {
        /**
         * 선택한 날짜데이터를 형식에 맞게 변환합니다.
         * @param obj
         */
        onSearchDateChanged(obj) {
            this.innerSelectOptions.startDate = obj.start && this.$parseDate(obj.start).toJSDate()
            this.innerSelectOptions.endDate = obj.end && this.$parseDate(obj.end).toJSDate()
            this.innerSelectOptions.pageNumber = 1
        },
        async loadCompanyOptions() {
            const res = await this.$request(PATH.MEMBERSHIP.LIST)
                .get()
                .catch(e => {
                    alert('조회실패')
                })
                .enqueue()
            const companyArr = res.data.map((
                {rentalcompany_id, rentalcompany_name}) => {
                return {codeKey: rentalcompany_id, codeValue: `${rentalcompany_name} [${rentalcompany_id}]`}
            })
            this.options.rentalcompanyId = [...companyArr];
        },
    },
    created() {
        this.loadCompanyOptions();//업체번호
    },
}
</script>

<style scoped>

.sales-select-box-wrapper {
    display: flex;
    height: 60px

}

.sales-select-box-style {
    width: 180px;
}
.rental-error-message{
    font-size: 10px;
    margin-top: 35px;
    text-align: left;
    color:#ff5252 !important
}

.main-toolbar[data-v-6772237e] {
    margin-bottom: 0px
}

>>> .v-input__control {
    width: 10px;
    height: 10px;
}

/* Select Box 에서 height부분 */
>>> .v-input__control .v-input__slot fieldset {
    height: 47px;
}

/* Select Box 에서 X 아이콘 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-icon {
    font-size: 19px;
}

/* Select Box 에서 label font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-label {
    font-size: 12px;
}

/* Month Select Box 에서 label font 부분 */
>>> .v-input__control .v-input__slot .v-text-field__slot .v-label {
    font-size: 12px;
}

>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections {
    padding: 0;
}

/*single Select Box 에서 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection {
    font-size: 12px;
    margin: 0;
}

/*Multi Select Box 에서 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections .text-truncate {
    font-size: 12px;
    margin: 0;
}

/*SearchSelectBox 에서 font 부분입니다.*/
>>> .v-select.v-text-field input {
    font-size: 12px !important;
    margin: 0 !important;
}
</style>